import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import Quest from "components/Quest";

import './index.less';
import './themes/default.less';

export default class TextArea extends MainComponent {
    static propTypes = {
        itemStyle: PropTypes.string,
        mainStyle: PropTypes.string,
        textareaStyle: PropTypes.string,
        placeHolder: PropTypes.string,
        label: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        onChange: PropTypes.func,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
        onClick: PropTypes.func,
        onKeyDown: PropTypes.func,
        required: PropTypes.bool,
        helpText: PropTypes.string,
    };
    static defaultProps = {
        itemStyle: "",
        mainStyle: "",
        textareaStyle: "text p1",
        placeHolder: "",
        label: "",
        value: null,
        onChange: null,
        onFocus: null,
        onBlur: null,
        onClick: null,
        onKeyDown: null,
        required: false,
        helpText: "",
    };

    componentDidMount() {
        if (this.props.value !== null)
            this.value = this.props.value;
        // Устанавливаем начальную высоту для value, если оно есть
        this.adjustHeight();
    }

    componentDidUpdate() {
        if (this.props.value !== null)
            this.value = this.props.value;
        // Корректируем высоту при обновлении
        this.adjustHeight();
    }

    get value() {
        return this.textarea.value;
    }

    set value(value) {
        return this.textarea.value = value;
    }

    onFocus() {
        this._helper.dom.addClass(this.textareaCont, "focused");
        if (this.props.onFocus?.apply)
            this.props.onFocus();
    }

    onBlur() {
        this._helper.dom.removeClass(this.textareaCont, "focused");
        if (this.props.onBlur?.apply)
            this.props.onBlur();
    }

    onChange() {
        if (this.props.onChange?.apply)
            this.props.onChange(this.value);
        // Корректируем высоту при каждом изменении
        this.adjustHeight();
    }

    adjustHeight() {
        // Сбрасываем высоту, чтобы пересчитать её
        this.textarea.style.height = 'auto';
        // Устанавливаем новую высоту в зависимости от содержимого
        this.textarea.style.height = this.textarea.scrollHeight + 'px';
    }

    render() {
        const { itemStyle, mainStyle, textareaStyle, label, placeHolder,
            onClick, onKeyDown, required, helpText } = this.props;
        const placeholder = placeHolder ? this.tr(placeHolder) : "";
        const reqSt = required ? "required" : "";

        return (
            <div ref={el => this.inputItem = el} className={`inputTextArea flex col gap8 ${itemStyle} ${reqSt}`}>
                <div className="flex between">
                    {!!label && (
                        <div className="textareaLabel text p2">{this.tr(label)}</div>
                    )}
                    {!!helpText && <Quest textTooltip={helpText} size={14} />}
                </div>
                <div
                    ref={el => this.textareaCont = el}
                    className={`textareaCont flex centerV rad4 ${mainStyle}`}
                >
                    <textarea
                        ref={el => this.textarea = el}
                        className={`textarea flex1 ${textareaStyle}`}
                        placeholder={placeholder}
                        spellCheck={false}
                        onFocus={this.onFocus.bind(this)}
                        onBlur={this.onBlur.bind(this)}
                        onChange={this.onChange.bind(this)}
                        onClick={onClick}
                        onKeyDown={onKeyDown}
                        style={{ overflow: 'hidden' }} // предотвращаем прокрутку
                    />
                </div>
            </div>
        );
    }
}
